/* eslint-disable react/prop-types */
import * as React from 'react';
import { FallbackProps } from 'react-error-boundary';

// interface ErrorBoundaryProps {
//   children: React.ReactNode;
//   fallbackComponent: React.ComponentType<FallbackProps>;
// }

// interface ErrorBoundaryState {
//   hasError: boolean;
// }

class ErrorBoundary extends React.Component {
  // class ErrorBoundary extends React.Component<
  //   ErrorBoundaryProps,
  //   ErrorBoundaryState
  // > {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children, fallbackComponent: FallbackComponent } = this.props;

    if (hasError) {
      return FallbackComponent ? <FallbackComponent /> : <div>Error</div>;
    }

    return children;
  }
}

export default ErrorBoundary;
